
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.571 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.743 4.433l-.419 10.06a.39.39 0 01-.381.364H2.629a.39.39 0 01-.382-.364l-.419-10.06a.571.571 0 10-1.142.048l.42 10.06A1.533 1.533 0 002.628 16h7.314a1.533 1.533 0 001.523-1.46l.42-10.06a.571.571 0 00-1.143-.047z"}}),_c('path',{attrs:{"d":"M5.829 5.371v7.772a.457.457 0 00.914 0V5.37a.457.457 0 00-.914 0zM3.314 5.385l.23 7.771a.457.457 0 00.913-.027l-.229-7.771a.457.457 0 10-.914.027zM8.343 5.358l-.229 7.771a.457.457 0 00.914.027l.229-7.771a.457.457 0 10-.914-.027zM.571 3.086H12a.571.571 0 000-1.143H.571a.571.571 0 000 1.143z"}}),_c('path',{attrs:{"d":"M4.55 2.328l.237-.832a.554.554 0 01.468-.353h2.061a.554.554 0 01.468.353l.238.832 1.099-.314-.238-.832A1.689 1.689 0 007.316 0h-2.06a1.689 1.689 0 00-1.567 1.182l-.238.832z"}})])
          )
        }
      }
    